import React, {useRef} from 'react';
import {Form} from "react-bootstrap";


const FakeRequiredInput = ({value,selectRef}) => {
    const ref = useRef()
    return (
        <React.Fragment>
            <Form.Control data-selectRef={selectRef?.id ?? selectRef} id={'fake-control'} itemRef={ref.current} isInvalid={!!value}   type={'input'} className={'fake-form-input'}  required={true} value={value ? true : ''}/>
        </React.Fragment>
    );
};

export default FakeRequiredInput;